import { create } from "zustand";

export const useFormActaStore = create((set) => ({
  tipos: null,
  barrios: null,
  screenMisActas: null,
  refetch: false,

  tiposSolicitudes: null,

  acta_id: null,
  ultimo_paso: 1,

  defaultValues: null,
  formActive: null,

  loading: true,

  setRefetch: (value) => {
    set({ refetch: value });
  },

  setTipos: (tipos) => {
    set({ tipos: tipos });
  },

  setTiposSolicitudes: (tiposSolicitudes) => {
    set({ tiposSolicitudes: tiposSolicitudes });
  },

  setBarrios: (barrios) => {
    set({ barrios: barrios });
  },

  setActaId: (id) => {
    set({ acta_id: id });
  },

  setUltimoPaso: (paso) => {
    set({ ultimo_paso: paso });
  },

  setLoading: (value) => {
    set({ loading: value });
  },

  setDefaultValues: (values) => {
    set({ defaultValues: values });
  },

  setFormActive: (value) => {
    set({ formActive: value });
  },

  setScreenMisActas: (value) => {
    set({ screenMisActas: value });
  },
}));
